Librarian.Modules.CategoryLinks = new Class({
    Extends: Librarian.Modules.Module,
    Binds: ["viewAll"],

    options: {
        classPrefix: "modules-categorylinks-",
        label: null,
        rootCat: 0,
        catPath: null,
        catId: -1,
        type: "files"
    },

    initialize: function(options, wrapperEl) {
        this.setOptions(options);
        this.parent(this.options, wrapperEl);
    },

    load: function() {
        var self = this;

        if (!this.wrapperEl) {
            return;
        }

        this.parent();

        if (!this.containerEl) { return; }

        if (this.options.type == "groups") {
            this.options.rootCat = Librarian.specialCategories.GlobalFavorites.CatId;
        }

        if (this.options.catPath)
            var url = Librarian.path.getMethodUrl("getcc") + "&pcid=" + this.options.rootCat + "&cid=" + this.options.catId + "&cpath=" + encodeURIComponent(this.options.catPath) + "&out=ljson";
        else 
            var url = Librarian.path.getMethodUrl("getcc") + "&cid=" + this.options.catId + "&out=ljson";
        
        this.request = new Librarian.Request.JSON({
            url: url,
            method: "get",
            onSuccess: function (response) {
                if (self.options.isSquare) {
                    // add view all button
                    new Element("span", {
                        "class": "viewAll",
                        events: {
                            click: function (event) {
                                self.viewAll(event, response);
                            }
                        },
                        text: "View all >"
                    }).injectInside(self.wrapperEl);
                }

                else if (self.options.viewAll) {
                    // add view all button
                    new Element("span", {
                        "class": "viewAll",
                        events: {
                            click: function (event) {
                                self.viewAll(event, response);
                            }
                        },
                        text: "View all"
                    }).injectInside(self.wrapperEl);
                }

                if (self.options.type == "files") {               
                    response.files.forEach(function(file) {
                        var linkEl = new Element("div", {
                            "class": "file-link",
                            events: {
                                click: function(event) {
                                    if ((file.filetypeextension.toUpperCase() == "URL") && Librarian.tileList.openURLOnClick)
                                        Librarian.Utils.openURLFile(file);
                                    else
                                        self.clickHandler(event, file);
                                }
                            }
                        }).injectInside(self.containerEl);

                        new Element("img", {
                            "class": "file-link-icon",
                            src: Librarian.Utils.getContentTypeIcon(file)
                        }).injectInside(linkEl);

                        new Element("span", {
                            "class": "file-link-text",
                            text: file.name.replace(".page", ""),
                            title: file.name.replace(".page", "")
                        }).injectInside(linkEl);
                    });
                }
                else if (self.options.type == "categories"){
                    response.subcategories.forEach(function(file) {                 
                        var linkEl = new Element("div", {
                            "class": "file-link",
                            events: {
                                click: function(event) {
                                    Librarian.Utils.selectTreeNodeByPath(treeView, self.options.catPath + "/" + file.name, null, true);
                                }
                            }
                        }).injectInside(self.containerEl);

                        new Element("span", {
                            "class": "file-link-text",
                            text: file.name,
                            title: file.name
                        }).injectInside(linkEl);

                        new Element("span", {
                            "class": "file-link-arrow"
                        }).injectInside(linkEl);
                    });
                }
                else if (self.options.type == "groups") {
                    response.groups = response.groups.slice(0, 8);
                    response.groups.forEach(function(group) {
                        var linkEl = new Element("div", {
                            "class": "file-link",
                            events: {
                                click: function(event) {
                                    self.clickHandler(event, group);
                                }
                            }
                        }).injectInside(self.containerEl);

                        new Element("img", {
                            "class": "file-link-icon",
                            src: Librarian.Utils.getContentTypeIcon(group)
                        }).injectInside(linkEl);

                        new Element("span", {
                            "class": "file-link-text",
                            text: group.name,
                            title: group.name
                        }).injectInside(linkEl);
                    });
                }
            }
        });
        this.request.send();   
    }, 

    clickHandler: function (event, file) {
        event.stopPropagation();
        Librarian.PreviewWindow.openPreviewWindow(file);
    },

    viewAll: function (event, response) {

            Librarian.Homepage.hide();
            if (Librarian.features.mountedVuePages.load)
                Librarian.Modules.MountedVuePage.hide();

            tileList.loadFromArray(response.files);

            var itemEl = $("pageheader");
            if (itemEl) {
                itemEl.show();
            }

            if(Librarian.pageheader != null) {
                Librarian.pageHeader.destroy();
                Librarian.pageHeader = null;
            }

            $('myInProgress').empty();

            Librarian.pageHeader = new Librarian.PageHeader({
                name: response.name,
                showHeaderMenu: false
            });
    }
});